
import React from 'react';
import ArcherInitialParameters from './components/ArcherInitialParameters';
import SwitchComponent from '../../../switch/Switch';
import { ArcherContext } from '../../context/ArcherContext';
const ArcherHeroBlock = (props) => {

    const {
        country,
        size,
        heatingType,
        setCountry,
        setCurrency,
        setSize,
        setHeatingType,
        renewableElectricity,
        setRenewableElectricity,
        setResultLookupTableIndex
    } = React.useContext(ArcherContext);

    const calculate = () => {
        setCurrency(props.countryTable.find((el) => el.country === country).currency);
        props.resultLookupTable.map((item, i) => {
            if (item.country === country &&
                item.size === size &&
                item.heatingType === heatingType
            ) {
                setResultLookupTableIndex(i);
            }
        });
    };

    React.useEffect(() => {
        setCountry(props.countryTable[0].country);
        setCurrency(props.countryTable[0].currency);
        setSize(props.size[0].size);
        setHeatingType(props.heatingType[0].name);
    }, []);

    return (
        <>
            <div className='calculator'>
                <div className='calculator__banner-wrapper_archer'>
                    <div className='calculator__banner' role="banner">
                        <div role="doc-subtitle" className="tagline">{props.tagLine}</div>
                        <h1 className='calculator__heading'>{props.heading}</h1>
                    </div>
                    <div className="calculator-rte">
                        <div dangerouslySetInnerHTML={{ __html: props.preamble }}></div>
                    </div>
                </div>

                <ArcherInitialParameters {...props} />
            </div>

            <div className="renewable-electricity-switch-wrapper">
                <SwitchComponent
                    onChange={setRenewableElectricity}
                    value={renewableElectricity}
                    checked={renewableElectricity}
                    label='100% Renewable Electricity'
                    id='archer-renewable-electricity-switch'
                    description={props.translations.renewableElectricityLabel} />

                <div className='calculator__button'>
                    <button className="button button--rounded calculator__calculate-button" onClick={() => {
                        props.handleDialogPopup('result');
                        calculate();

                    }}>
                        {props.translations.calculateLabel}
                    </button>
                </div>
            </div>
        </>
    );
};

export default ArcherHeroBlock;
